import axiosInstance from "./axios-instance";

const listEnquiries = (params) =>
    axiosInstance.get("/app/tk-enquiries", { params, cache: false }).then(res => res);

const createEnquiry = (enquiry) =>
    axiosInstance.post("/app/tk-enquiries", enquiry).then(res => res);

const updateEnquiry = (enquiryId, enquiry) =>
    axiosInstance.patch(`/app/tk-enquiries/${enquiryId}`, enquiry).then(res => res);

export default {
    listEnquiries,
    createEnquiry,
    updateEnquiry,
};
